import OperationButton from "@/components/FollowButton/operationButton";
import { SOURCE_TYPE_ICONS } from "@/constants/sourceTypeIcon";
import useAppStore from "@/context/store";
import displayNum from "@/utils/displayNum";
import imageUrl from "@/utils/imageUrl";
import { Button, Dropdown } from "antd";
import _ from "lodash";
import Link from "next/link";
import { useMemo, useState } from "react";
import { When } from "react-if";
import HBIcon from "../HBIcon";
import Image from "../Image";
import styles from "./index.module.less";

export default function PinPreview({ pin, children }) {
  const [btnText, setBtnText] = useState("已关注");
  const domains = useAppStore((s) => s.domains);
  const sourceDetail = useMemo(() => {
    const { source_type, source_detail } = pin;
    const info = {};

    if (source_type === 1) {
      // 画板
      info.source_type_name = "画板";
      info.source_title = source_detail?.title;
      info.source_link = `/boards/${source_detail?.board_id}`;
      info.source_avatar = imageUrl(pin.file, { width: 80 });
    } else if (source_type === 2) {
      // 用户
      info.source_type_name = "用户";
      info.source_title = source_detail?.username;
      info.source_link = `/user/${source_detail?.urlname}`;
      info.source_avatar = imageUrl(pin.user.avatar, { width: 80 });
    } else if (source_type === 3) {
      const domain = domains.find(
        (item) => item.domainId === source_detail.domain_id
      );

      // 来源
      info.source_type_name = "来源";
      info.source_title = source_detail?.domain_name;
      info.source_link = `/domains/${source_detail?.domain_id}`;
      info.source_avatar = domain ? domain.domainLogo[0]?.url : "";
      info.source_avatar_text = _.upperFirst(
        source_detail.root_domain_name?.split("")?.slice(0, 2)?.join("") || ""
      );
    }

    return {
      pin_count: 0,
      follow_count: source_detail.follower_count || 0,
      source_type,
      ...info,
      ...source_detail,
    };
  }, [pin, domains]);

  const preview = useMemo(() => {
    return (
      <div className={styles.preview}>
        <div className={styles.inner}>
          <div className={styles.avatar}>
            {sourceDetail.source_avatar ? (
              <Link href={sourceDetail.source_link} passHref>
                <a target={"_blank"}>
                  <Image src={sourceDetail.source_avatar} alt="来源" />
                </a>
              </Link>
            ) : (
              <div className={styles.draw}>
                {sourceDetail.source_avatar_text}
              </div>
            )}
          </div>
          <div className={styles.info}>
            <Link href={sourceDetail.source_link} passHref>
              <a className={styles.title} target={"_blank"}>
                {sourceDetail.source_title || "--"}
              </a>
            </Link>
            <div className={styles.desc}>
              <HBIcon
                className={styles.icon}
                type={SOURCE_TYPE_ICONS[sourceDetail.source_type]}
              />
              {sourceDetail.source_type_name}
            </div>
            <When condition={sourceDetail.source_type !== 3}>
              <div className={styles.desc}>
                <HBIcon className={styles.icon} type="ic_tag" />
                {`${displayNum(sourceDetail.pin_count)}采集  ${displayNum(
                  sourceDetail.follow_count
                )}粉丝`}
              </div>
            </When>
          </div>
        </div>
        <a
          target="_blank"
          href={sourceDetail.source_link}
          rel="noreferrer"
          onMouseEnter={() => setBtnText("访问详情页")}
          onMouseLeave={() => setBtnText("已关注")}
        >
          {sourceDetail.source_type_name === "用户" ||
          sourceDetail.source_type_name === "画板" ? (
            <OperationButton
              btnText={btnText}
              className={styles.operationButton}
              userInfo={
                sourceDetail.source_type_name === "用户" ? pin.user : undefined
              }
              boardInfo={
                sourceDetail.source_type_name === "画板"
                  ? sourceDetail
                  : undefined
              }
              getPopupContainer={() => document.body}
            ></OperationButton>
          ) : (
            <Button className={styles.btn} block>
              {btnText}
            </Button>
          )}
        </a>
      </div>
    );
  }, [sourceDetail, btnText, pin.user]);

  return (
    <Dropdown
      overlayClassName={styles.overlay}
      overlay={preview}
      placement="topLeft"
    >
      {children}
    </Dropdown>
  );
}
